import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import Modal from '../../Modal';
import Spinner from '../../Spinner';
import Form, { FormBody, FormActions, SelectInput, DateInput, TextInput } from '../../Form';
import { token } from '../../../libs/localStorage';
import moment from "moment/moment";
import FormMultiSelectInput from "../../FormMultiSelectInput";

@inject('workOrderStore', 'workOrderStatusStore', 'priorityStore', 'maintenanceTypeStore', 'userStore', 'inventoryItemStore', 'stationStore', 'ticketStore')
@observer
class WorkOrderEdit extends Component {
  @observable multiStationOptions = [];
  @observable multiTicketOptions = [];

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired
  };

  slug = this.props.params.work_order_id ? `station/${this.props.params.id}/maintenance/work_order` : '/monitoring/work_order';
  title = 'Edit Work Order';

  @observable item = {
    title: '',
    scheduled_date: null,
    priority: null,
    maintenance_type: null,
    completion_deadline: null,
    creation_date: null,
    created_by: +token.getDecoded().id,
    assigned_to: null,
    status: null,
    station: [],
    ticket: []
  };

  @action onChangeTitle = e => this.item.title = e.target.value;
  @action onChangePriority = e => this.item.priority = +e.target.value;
  @action onChangeMaintenanceType = e => this.item.maintenance_type = +e.target.value;
  @action onChangeCompletionDeadline = e => this.item.completion_deadline = e.target.value;
  @action onChangeCreationDate = e => this.item.creation_date = e.target.value;
  @action onChangeScheduledDate = e => this.item.scheduled_date = e.target.value;
  @action onChangeAssignedTo = e => this.item.assigned_to = +e.target.value;
  @action onChangeStatus = e => this.item.status = +e.target.value;

  constructor(props) {
    super(props);

    const { params: { id, work_order_id }, workOrderStore } = props;

    // workOrderStore.fetchItem(work_order_id || id);
  }

  componentWillMount() {
    this.reset();
  }

  @action reset() {

    const { params: { id, work_order_id }, workOrderStore } = this.props;
    const foundItem = workOrderStore.findById(work_order_id || id);
    // this.item = foundItem.asJson
    if (foundItem) {
      this.item = {
        ...foundItem.asJson,
        ticket: foundItem.ticket,
        station: foundItem.station
      };
      const { stationStore, ticketStore } = this.props;

      this.multiStationOptions = this.props.stationStore.items.map(item => ({
        id: item.id,
        name: item.name,
        label: item.name,
        value: this.item.station && !!this.item.station.find(s => +s.id === +item.id)
      }));

      this.multiTicketOptions = this.props.ticketStore.items.filter(t => !t.archived).map(item => ({
        id: item.id,
        station_id: item.station_id,
        name: item.summary,
        label: item.summary ? item.summary.toString() : item.id.toString(),
        value: this.item.ticket && !!this.item.ticket.find(t => +t.id === +item.id)
      }));
    }
  }

  handleSave = (e) => {
    e.preventDefault();

    const { workOrderStore } = this.props;

    const { ticket, priority, status, station, ...others } = this.item;

    workOrderStore.updateItem({
      station: this.multiStationOptions.filter(s => s.value).map(s => ({
        id: +s.id,
        name: s.name
      })),
      ticket: this.multiTicketOptions.filter(t => t.value).map(t => ({
        id: +t.id,
        summary: t.name
      })),
      ...others,
      priority,
      status
    })
      .then(() => {
        this.context.notify.success({ message: "Saved" })
        this.context.router.push(this.slug);
      }).catch(() => this.context.notify.error({ message: "Somthing is wrong !" }));
  }

  @action
  onStationSelect = (item) => {
    item.value = !item.value;
    this.multiTicketOptions.filter(t => +t.station_id === +item.id).forEach(t => t.value = false);
  }

  @action
  onTicketSelect = (item) => {
    item.value = !item.value;
  }

  render() {
    const { workOrderStore, ticketStore, workOrderStatusStore, priorityStore, maintenanceTypeStore, userStore, stationStore, params: { id } } = this.props;

    if (workOrderStore.isLoading) {
      return <Spinner />;
    }

    const selectedMultiStations = this.multiStationOptions.filter(s => s.value).map(s => +s.id);

    return (
      <Modal title={this.title} slug={this.slug} isSaving={workOrderStore.isSaving}>
        <Form>
          <FormBody>
            <TextInput label={"Title"} onChange={this.onChangeTitle} value={this.item.title} />
            <FormMultiSelectInput id='station-multi-select' sortBy={'name'} label='Stations' options={this.multiStationOptions} optionClicked={item => this.onStationSelect(item)} isLoading={stationStore.isLoading} />
            <FormMultiSelectInput id='ticket-multi-select' label='Related Tickets' options={this.multiTicketOptions.filter(ticket => selectedMultiStations.includes(+ticket.station_id))} optionClicked={item => this.onTicketSelect(item)} isLoading={ticketStore.isLoading} />
            <SelectInput label='Priority' options={priorityStore.items} fields={{ value: 'id', label: 'caption' }} value={this.item.priority} onChange={this.onChangePriority} />
            <SelectInput label='Maintenance Type' options={maintenanceTypeStore.items} fields={{ value: 'id', label: 'caption' }} value={this.item.maintenance_type} onChange={this.onChangeMaintenanceType} />
            <SelectInput label='Status' options={workOrderStatusStore.items} fields={{ value: 'id', label: 'caption' }} value={this.item.status} onChange={this.onChangeStatus} />
            <SelectInput label='Assigned To' options={userStore.items} fields={{ value: 'id', label: 'name' }} value={this.item.assigned_to} onChange={this.onChangeAssignedTo} />
            <DateInput label='Creation Date' value={this.item.creation_date} onChange={this.onChangeCreationDate} />
            <DateInput label='Completion Deadline' value={this.item.completion_deadline} onChange={this.onChangeCompletionDeadline} />
            <DateInput label='Scheduled Date' value={this.item.scheduled_date} onChange={this.onChangeScheduledDate} />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default WorkOrderEdit;



// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/WorkOrderEdit.js